import type {
  CreateReconciliationInput,
  MatchInput,
  ReconciliationItem,
  ReconciliationListResult,
  ReconciliationStats,
  ResolveInput,
} from "@/modules/wallet/domain/repo/reconciliation";
import type { OffsetPageQueryDTO } from "@/shared/contracts/base";
import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";

export type {
  ReconciliationItem,
  ReconciliationListResult,
  ReconciliationStats,
};

export const reconciliationApi = {
  async getStats(): Promise<ReconciliationStats> {
    return fetcher.get<ReconciliationStats>(
      `${config.apiUrl}/reconciliation/stats`,
    );
  },

  async list(query: OffsetPageQueryDTO): Promise<ReconciliationListResult> {
    const url = new URL(`${config.apiUrl}/reconciliation`);
    url.searchParams.set("limit", String(query.limit ?? 20));
    url.searchParams.set("offset", String(query.offset ?? 0));
    if (query.sort) url.searchParams.set("sort", JSON.stringify(query.sort));
    if (query.filters)
      url.searchParams.set("filters", JSON.stringify(query.filters));
    return fetcher.get<ReconciliationListResult>(url.toString());
  },

  async getDetail(id: string): Promise<ReconciliationItem> {
    return fetcher.get<ReconciliationItem>(
      `${config.apiUrl}/reconciliation/${id}`,
    );
  },

  async importRecords(
    records: CreateReconciliationInput[],
  ): Promise<{ count: number }> {
    return fetcher.post<{ count: number }>(
      `${config.apiUrl}/reconciliation/import`,
      { records },
    );
  },

  async match(id: string, body: MatchInput): Promise<{ ok: boolean }> {
    return fetcher.post<{ ok: boolean }>(
      `${config.apiUrl}/reconciliation/${id}/match`,
      body,
    );
  },

  async resolve(id: string, body: ResolveInput): Promise<{ ok: boolean }> {
    return fetcher.post<{ ok: boolean }>(
      `${config.apiUrl}/reconciliation/${id}/resolve`,
      body,
    );
  },
};
